import { MdEdit } from 'react-icons/md';
import styled from 'styled-components';

export const EditButtonBase = styled(MdEdit)`
  font-size: 18px;
  &:hover {
    cursor: pointer;
  }
`;
